<app-breadcrumb  [master]="'Analizy'" [parentName]="'Partnerzy'" [name]="'Raporty'"></app-breadcrumb>
<div class="report-partners-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="report-partners-list-filters">
    <mat-form-field class="report-partners-list-filter">
      <mat-label>ID</mat-label>
      <input matInput placeholder="12345" name="recordId" [(ngModel)]="initialFilters.recordId">
    </mat-form-field>

    <app-dict
      [dictType]="'legal_form'" [label]="'Forma prawna'"
      class="report-partners-list-filter"
      [(ngModel)]="initialFilters.legalForm" name="legalForm"
    ></app-dict>

    <app-dict
      [multiple]="true" [dictType]="'form_of_business'"
      [label]="'Typ działalności'" class="report-partners-list-filter"
      [(ngModel)]="initialFilters.in$formOfBusiness" name="in$formOfBusiness"
    ></app-dict>

    <mat-form-field class="report-partners-list-filter">
      <mat-label>Pełna nazwa</mat-label>
      <input matInput placeholder="Pełna nazwa" name="contains$fullName" [(ngModel)]="initialFilters.contains$fullName">
    </mat-form-field>

    <mat-form-field class="report-partners-list-filter">
      <mat-label>Nazwa skrócona</mat-label>
      <input matInput placeholder="Nazwa skrócona" name="contains$shortName" [(ngModel)]="initialFilters.contains$shortName">
    </mat-form-field>

    <mat-form-field class="report-partners-list-filter">
      <mat-label>NIP</mat-label>
      <input matInput placeholder="NIP" name="contains$nip" [(ngModel)]="initialFilters.contains$nip">
    </mat-form-field>

    <mat-form-field class="report-partners-list-filter">
      <mat-label>REGON</mat-label>
      <input matInput placeholder="REGON" name="contains$regon" [(ngModel)]="initialFilters.contains$regon">
    </mat-form-field>

    <mat-form-field class="report-partners-list-filter">
      <mat-label>KRS</mat-label>
      <input matInput placeholder="KRS" name="contains$krs" [(ngModel)]="initialFilters.contains$krs">
    </mat-form-field>

    <mat-form-field class="report-partners-list-filter">
      <mat-label>Email</mat-label>
      <input matInput placeholder="Email" name="email" [(ngModel)]="initialFilters.email">
    </mat-form-field>

    <mat-form-field class="report-partners-list-filter">
      <mat-label>Numer telefonu</mat-label>
      <input matInput placeholder="Numer telefonu" name="phone" [(ngModel)]="initialFilters.phone">
    </mat-form-field>

    <mat-form-field class="report-partners-list-filter">
      <mat-label>Nr rachunku</mat-label>
      <input matInput placeholder="Nr rachunku" name="contains$accountNumber" [(ngModel)]="initialFilters.contains$accountNumber">
    </mat-form-field>

    <mat-form-field appearance="standard" class="report-partners-list-filter">
      <mat-label>Płatnik VAT</mat-label>
      <mat-select [(ngModel)]="initialFilters.vatPayer" name="vatPayer">
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

    <app-dict
      [multiple]="true" [dictType]="'partner_status'"
      [label]="'Status'" class="report-partners-list-filter"
      [(ngModel)]="initialFilters.in$status" name="in$status"
    ></app-dict>

    <app-dict-regionals
      [noneEntry]="true" [multiple]="true" [label]="'Regionalny (majątek)'"
      class="report-partners-list-filter" [(ngModel)]="initialFilters.assetsRegional" name="assetsRegional"
    ></app-dict-regionals>

    <app-dict-regionals
      [noneEntry]="true" [multiple]="true"
      [label]="'Regionalny (życie)'" class="report-partners-list-filter"
      [(ngModel)]="initialFilters.lifeRegional" name="lifeRegional"
    ></app-dict-regionals>

    <mat-form-field class="report-partners-list-filter">
      <mat-label >Przypis do</mat-label>
      <input matInput placeholder="lista" name="headers" [(ngModel)]="initialFilters.headers">
    </mat-form-field>

    <mat-form-field class="report-partners-list-filter report-partners-list-filter-address">
      <mat-label>Adres</mat-label>
      <input matInput placeholder="Armii Krajowej 18, Siedlce 08-110" name="address" [(ngModel)]="initialFilters.address">
    </mat-form-field>

    <app-dict
      [multiple]="false" [dictType]="'address_state'"
      [label]="'Województwo'" class="report-partners-list-filter"
      [(ngModel)]="initialFilters.state" name="state"
    ></app-dict>

    <app-dict
      class="report-partners-list-filter" [label]="'Tagi'"
      [dictType]="'partner_tags'"
      [required]="false" [multiple]="true"
      [(ngModel)]="initialFilters.tags" name="tags"
    ></app-dict>

    <mat-form-field appearance="standard" class="report-partners-list-filter">
      <mat-label>Rekord zweryfikowany</mat-label>
      <mat-select [(ngModel)]="initialFilters.verified" name="verified">
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="standard" class="report-partners-list-filter">
      <mat-label>Samofakturowanie</mat-label>
      <mat-select [(ngModel)]="initialFilters.selfBilling" name="selfBilling">
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>
  </form>

  <div class="report-partners-list-buttons">
    <button *ngIf="(userPermissions | async).analysis.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).analysis.read_report"
            mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

</div>
